import { render, staticRenderFns } from "./BookingSource.vue?vue&type=template&id=38550dc3&scoped=true"
import script from "./BookingSource.vue?vue&type=script&lang=js"
export * from "./BookingSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38550dc3",
  null
  
)

export default component.exports